var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendario(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M254.1,27.3h-29.7V12.4c0-4.1-3.3-7.4-7.4-7.4c-4.1,0-7.4,3.3-7.4,7.4v14.9h-119V12.4c0-4.1-3.3-7.4-7.4-7.4 c-4.1,0-7.4,3.3-7.4,7.4v14.9H45.9C25.4,27.3,8.7,44,8.7,64.5v193.3c0,20.5,16.7,37.2,37.2,37.2h208.2c20.5,0,37.2-16.7,37.2-37.2 V64.5C291.3,44,274.6,27.3,254.1,27.3z M122,254.8H89.7v-32.3H122V254.8z M186.5,254.8h-32.3v-32.3h32.3V254.8z M186.5,190.3h-32.3 V158h32.3V190.3z M251.1,254.8h-32.3v-32.3h32.3V254.8z M251.1,190.3h-32.3V158h32.3V190.3z M276.4,101.7H23.6V64.5 c0-12.3,10-22.3,22.3-22.3h29.7v14.9c0,4.1,3.3,7.4,7.4,7.4c4.1,0,7.4-3.3,7.4-7.4V42.2h119v14.9c0,4.1,3.3,7.4,7.4,7.4 c4.1,0,7.4-3.3,7.4-7.4V42.2h29.7c12.3,0,22.3,10,22.3,22.3V101.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendario);
export default __webpack_public_path__ + "static/media/calendario.b4fef684c74fa17b64c8ee67ab4daaaf.svg";
export { ForwardRef as ReactComponent };